// @ts-nocheck
import { Box, ThemeProvider } from "@smoothie-framework/ui";
import { zequelsTheme } from "../../../shared/theme";
import { Audio } from "./audio";
import { Cinema } from "./cinema";
import { Creators } from "./creators";
import { Footer } from "./footer";
import { Header } from "./header";
import { Hero } from "./hero";
import { Pipeline } from "./pipeline";
import { StoryBible } from "./story-bible";
import { Workflow } from "./workflow";

export function App() {
  return (
    <ThemeProvider theme={zequelsTheme} applyCssVariables>
      <Box
        as="main"
        className="zequels-landing"
        background="background"
        color="text"
        w="full"
      >
        <Header />
        <Hero />
        <Pipeline />
        <Cinema />
        <Workflow />
        <StoryBible />
        <Audio />
        <Creators />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
